(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wvh-book-a-call"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(scope) {
      var roots = (scope || document).querySelectorAll('[data-book]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    function jsonp(url, params) {
      return new Promise(function (resolve, reject) {
        var cb = 'wvhBook' + Math.random().toString(36).slice(2, 10);
        var script = document.createElement('script');
        var timer = setTimeout(function () { cleanup(); reject(new Error('timeout')); }, 20000);
        function cleanup() {
          clearTimeout(timer);
          try { delete window[cb]; } catch (e) { window[cb] = undefined; }
          if (script.parentNode) script.parentNode.removeChild(script);
        }
        window[cb] = function (data) { cleanup(); resolve(data); };
        var qs = [];
        for (var k in params) {
          if (Object.prototype.hasOwnProperty.call(params, k) && params[k] !== undefined && params[k] !== '') {
            qs.push(encodeURIComponent(k) + '=' + encodeURIComponent(params[k]));
          }
        }
        qs.push('callback=' + cb);
        script.src = url + (url.indexOf('?') === -1 ? '?' : '&') + qs.join('&');
        script.onerror = function () { cleanup(); reject(new Error('network')); };
        document.head.appendChild(script);
      });
    }

    function init(root) {
      if (!root || root.dataset.bookReady === '1') return;
      var cfgEl = root.querySelector('[data-book-config]');
      if (!cfgEl) return;
      var cfg;
      try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
      root.dataset.bookReady = '1';

      var panes = {};
      root.querySelectorAll('[data-state]').forEach(function (el) { panes[el.getAttribute('data-state')] = el; });

      function show(name) {
        Object.keys(panes).forEach(function (k) { panes[k].hidden = (k !== name); });
      }

      var elDays = root.querySelector('[data-days]');
      var elSlots = root.querySelector('[data-slots]');
      var elTz = root.querySelector('[data-tz]');
      var elChosen = root.querySelector('[data-chosen]');
      var elForm = root.querySelector('[data-form]');
      var elSubmit = root.querySelector('[data-submit]');
      var elFormError = root.querySelector('[data-form-error]');
      var elDoneWhen = root.querySelector('[data-done-when]');
      var elMeetWrap = root.querySelector('[data-meet-wrap]');
      var elMeet = root.querySelector('[data-meet]');
      var elErrorCopy = root.querySelector('[data-error-copy]');

      var days = [];
      var dayIdx = 0;
      var chosen = null;
      var idemKey = null;

      var localZone = '';
      try { localZone = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}

      function fmtTime(d) {
        try {
          return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
        } catch (e) {
          return d.getHours() + ':' + ('0' + d.getMinutes()).slice(-2);
        }
      }
      function fmtDayLong(d) {
        return d.toLocaleDateString([], { weekday: 'long', month: 'long', day: 'numeric' });
      }
      function zoneLabel(d) {
        try {
          var p = new Intl.DateTimeFormat([], { timeZoneName: 'short' }).formatToParts(d);
          for (var i = 0; i < p.length; i++) if (p[i].type === 'timeZoneName') return p[i].value;
        } catch (e) {}
        return localZone;
      }

      function group(slots) {
        var out = [];
        var index = {};
        slots.forEach(function (iso) {
          var d = new Date(iso);
          if (isNaN(d.getTime())) return;
          var key = d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate();
          if (!index[key]) {
            index[key] = { date: d, slots: [] };
            out.push(index[key]);
          }
          index[key].slots.push(d);
        });
        return out;
      }

      function drawDays() {
        elDays.innerHTML = '';
        days.forEach(function (day, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'book__day';
          b.setAttribute('aria-pressed', i === dayIdx ? 'true' : 'false');
          b.innerHTML = '<span>' + day.date.toLocaleDateString([], { weekday: 'short' }) + '</span>' +
            day.date.getDate() + ' ' + day.date.toLocaleDateString([], { month: 'short' });
          b.addEventListener('click', function () { dayIdx = i; drawDays(); drawSlots(); });
          elDays.appendChild(b);
        });
      }

      function drawSlots() {
        elSlots.innerHTML = '';
        if (!days.length) return;
        days[dayIdx].slots.forEach(function (slot) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'book__slot';
          b.textContent = fmtTime(slot);
          b.addEventListener('click', function () { choose(slot); });
          elSlots.appendChild(b);
        });
      }

      function choose(slot) {
        chosen = slot;
        idemKey = 'k' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
        elChosen.innerHTML = '<strong>' + fmtDayLong(slot) + '</strong> at <strong>' + fmtTime(slot) + ' ' + zoneLabel(slot) + '</strong>';
        elFormError.hidden = true;
        show('details');
      }

      function renderSlots(list) {
        days = group(list);
        dayIdx = 0;
        if (!days.length) {
          show('pick');
          elDays.innerHTML = '';
          elSlots.innerHTML = '';
          var p = document.createElement('p');
          p.className = 'book__empty';
          p.textContent = cfg.emptyCopy;
          elSlots.appendChild(p);
          elTz.textContent = '';
          return;
        }
        drawDays();
        drawSlots();
        elTz.textContent = 'Times shown in your time zone' + (localZone ? ' (' + localZone.replace(/_/g, ' ') + ')' : '') + '.';
        show('pick');
      }

      function loadSlots() {
        show('loading');
        return jsonp(cfg.api, {}).then(function (res) {
          if (!res || !res.ok) throw new Error((res && res.error) || 'bad_response');
          renderSlots(res.slots || []);
        }).catch(function () {
          if (elErrorCopy) elErrorCopy.textContent = cfg.errorCopy;
          show('error');
        });
      }

      var back = root.querySelector('[data-back]');
      if (back) back.addEventListener('click', function () { show('pick'); });

      if (elForm) {
        elForm.addEventListener('submit', function (e) {
          e.preventDefault();
          if (!chosen) return;
          var name = root.querySelector('[data-name]').value.trim();
          var email = root.querySelector('[data-email]').value.trim();
          var company = root.querySelector('[data-company]').value.trim();
          var project = root.querySelector('[data-project]').value.trim();

          if (!name || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
            elFormError.textContent = 'Please add your name and a valid email address.';
            elFormError.hidden = false;
            return;
          }

          elFormError.hidden = true;
          elSubmit.disabled = true;
          var label = elSubmit.textContent;
          elSubmit.textContent = cfg.busyLabel;

          jsonp(cfg.api, {
            action: 'book',
            name: name,
            email: email,
            company: company,
            project: project,
            start: chosen.toISOString(),
            key: idemKey
          }).then(function (res) {
            if (res && res.ok) {
              elDoneWhen.textContent = fmtDayLong(chosen) + ' at ' + fmtTime(chosen) + ' ' + zoneLabel(chosen);
              if (res.meetLink && elMeet) {
                elMeet.href = res.meetLink;
                elMeetWrap.hidden = false;
              }
              show('done');
              return;
            }
            if (res && res.error === 'slot_taken') {
              elSubmit.disabled = false;
              elSubmit.textContent = label;
              loadSlots().then(function () {
                elFormError.hidden = true;
                var note = document.createElement('p');
                note.className = 'book__empty';
                note.textContent = cfg.takenCopy;
                elSlots.parentNode.insertBefore(note, elSlots);
              });
              return;
            }
            throw new Error('book_failed');
          }).catch(function () {
            elSubmit.disabled = false;
            elSubmit.textContent = label;
            elFormError.textContent = 'That did not go through. Please try again, or call us and we will book it for you.';
            elFormError.hidden = false;
          });
        });
      }

      if (!cfg.api) {
        if (elErrorCopy) elErrorCopy.textContent = cfg.errorCopy;
        show('error');
        return;
      }
      loadSlots();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wvh-promo-bar"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.promobar').forEach(function(bar){
      if(bar.dataset.pbInit) return; bar.dataset.pbInit='1';
      var items=bar.querySelectorAll('.promobar__item');
      if(items.length<2) return;
      var i=0, ms=parseInt(bar.dataset.interval,10)||1500;
      var mq=window.matchMedia('(max-width:47.99em)');
      setInterval(function(){
        if(!mq.matches) return;               /* rotate on mobile only; desktop shows all */
        items[i].classList.remove('is-active');
        i=(i+1)%items.length;
        items[i].classList.add('is-active');
      }, ms);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wvh-variable-hero"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function root(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/'; }
    function debounce(fn,ms){ var t; return function(){ var a=arguments, c=this; clearTimeout(t); t=setTimeout(function(){ fn.apply(c,a); }, ms); }; }
    function esc(s){ return (s||'').replace(/[&<>"]/g,function(m){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]; }); }
    function init(form){
      if(form.dataset.psInit) return; form.dataset.psInit='1';
      var input=form.querySelector('.nlsearch__input');
      var box=form.parentNode.querySelector('.nlsearch__results');
      if(!input||!box) return;
      function close(){ box.hidden=true; box.innerHTML=''; }
      function render(q,products){
        if(!products.length){ box.innerHTML='<div class="nlr__empty">No matches for “'+esc(q)+'”</div>'; box.hidden=false; return; }
        var html=products.map(function(p){
          var img=p.image ? '<div class="nlr__img"><img src="'+p.image+'&width=200" alt="" width="96" height="128" loading="lazy"></div>' : '<div class="nlr__img"></div>';
          var price=p.price ? '<div class="nlr__price">'+esc(p.price)+'</div>' : '';
          return '<a class="nlr" href="'+p.url+'">'+img+'<div><div class="nlr__name">'+esc(p.title)+'</div>'+price+'</div></a>';
        }).join('');
        html+='<a class="nlsearch__all" href="'+root()+'search?q='+encodeURIComponent(q)+'&type=product">View all results</a>';
        box.innerHTML=html; box.hidden=false;
      }
      var run=debounce(function(){
        var q=input.value.trim();
        if(q.length<2){ close(); return; }
        var url=root()+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=8';
        fetch(url,{headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }).then(function(d){
          var prods=(d && d.resources && d.resources.results && d.resources.results.products) || [];
          render(q,prods);
        }).catch(function(){ close(); });
      },220);
      input.addEventListener('input',run);
      input.addEventListener('focus',function(){ if(input.value.trim().length>=2) run(); });
      input.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
      document.addEventListener('click',function(e){ if(!form.parentNode.contains(e.target)) close(); });
    }
    function boot(){ document.querySelectorAll('.nlsearch').forEach(init); }
    if(document.readyState!=='loading'){ boot(); } else { document.addEventListener('DOMContentLoaded',boot); }
  })();

  } catch(e) { console.error(e); }
})();
})();
